function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22,17v-0.5c0-1.38-1.12-2.5-2.5-2.5S17,15.12,17,16.5V17c-0.55,0-1,0.45-1,1v4c0,0.55,0.45,1,1,1h5c0.55,0,1-0.45,1-1v-4 C23,17.45,22.55,17,22,17z M21,17h-3v-0.5c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5V17z M15,18v2H4.5v-0.941 c0-3.325,3.084-5.647,7.5-5.647c1.813,0,3.395,0.396,4.637,1.087c-0.356,0.508-0.586,1.11-0.63,1.764C15.406,16.609,15,17.258,15,18 z M8.25,7.765C8.25,5.69,9.932,4,12,4s3.75,1.69,3.75,3.765c0,2.076-1.682,3.765-3.75,3.765C9.933,11.53,8.25,9.84,8.25,7.765z"
});

var SvgPersonLock = function SvgPersonLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person-lock.6f349610.svg";
export { ForwardRef as ReactComponent };